import React, { PureComponent } from 'react';
import { getPatient, getPrescription } from '../../../../store/selectors/prescriptionPad';
import { GlobalState } from '../../../../store/reducers';
import { connect } from 'react-redux';
import { getDoc, getPatientByLocalId } from '../../../../store/idbHandler';
import { PatientWithLocalId, Prescription } from '../../../../store/types/prescription';
import { motion } from 'framer-motion';
import { EKA_EVENT } from '../../../../bridge/events/dispatch';
import { Events } from '../../../../bridge/events/types';
import { Patient } from '../../../../store/types/patient';
import MedicalCertificateDialog from '../../../common/MedicalCertificateDialog';
import { CUSTOM_CERT_ID } from '../../../common/medicalCertificates';

type Props = {
    patient?: PatientWithLocalId;
    closeMe: () => void;
    isGlobal?: boolean;
    px?: Prescription;
    docid: string;
};

type State = { medCert: { show: boolean; message?: string; patient?: Patient } };
export class DocAssistComp extends PureComponent<Props, State> {
    elementRef: React.RefObject<HTMLInputElement>;

    constructor(props: Props) {
        super(props);
        this.elementRef = React.createRef();
        this.state = { medCert: { show: false } };
    }

    onEkaEvent = (event: Event): void => {
        const { detail } = event as CustomEvent<Events>;
        if (detail.type === 'CHAT_MEDCERT_COPY' && this?.props?.patient?.id) {
            const mrkdnMsg = detail.message;
            getPatientByLocalId(this.props.patient.id).then((patient) =>
                this.setState({ medCert: { show: true, message: mrkdnMsg, patient } }),
            );
        }
    };

    componentDidMount(): void {
        window.addEventListener(EKA_EVENT, this.onEkaEvent);
    }

    componentWillUnmount = (): void => {
        window.DOC_ASSIST_CONFIG = undefined;
        window.removeEventListener(EKA_EVENT, this.onEkaEvent);
    };

    closeMedCert = (): void => {
        this.setState({ medCert: { show: false } });
    };

    render() {
        const { patient, closeMe, isGlobal, docid } = this.props;

        if (!docid || (!isGlobal && !patient?.id)) {
            return null;
        }

        return (
            <>
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="font-lato absolute inset-0"
                    style={{ zIndex: 10 }}
                >
                    <div onClick={closeMe} className="modal-overlay" />

                    <div
                        className="flex flex-col modal-content w-50p overflow-auto"
                        style={{
                            height: '540px',
                            maxHeight: '540px',
                            minHeight: '540px',
                            width: '720px',
                            minWidth: '720px',
                            maxWidth: '720px',
                        }}
                        ref={this.elementRef}
                    >
                        <doc-assist
                            docId={docid}
                            ptId={patient?.id}
                            rx={this.props.px ? JSON.stringify(this.props.px) : undefined}
                        />
                    </div>
                </motion.div>
                {this.state.medCert.show && this.state.medCert.patient ? (
                    <MedicalCertificateDialog
                        patient={this.state.medCert.patient}
                        closeMe={this.closeMedCert}
                        defaultState={{
                            page: 'create-cr',
                            type: 'mcert',
                            selectedCertificate: CUSTOM_CERT_ID,
                        }}
                        customCertificateContent={this.state.medCert.message}
                        docid={docid}
                    />
                ) : null}
            </>
        );
    }
}

export default connect((state: GlobalState) => ({
    patient: getPatient(state),
    px: getPrescription(state),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
}))(DocAssistComp);
